<template>
	<div class="login">
	    <div class="login_1">
            <div class="login_1_1">
                <img :src="require('../assets/login/logo.png')" />
            </div>
            <div class="login_1_2">
                <div class="login_wrap">
                    <div class="login_title">货满满数字物流</div>
                    <div class="login_body">
                        <van-field 
                        v-model="loginForm.account" 
                        type="tel" 
                        placeholder="请输入账号" 
                        :left-icon="require('../assets/login/user.png')" 
                        :border="false"
                        />
                        <van-field 
                        v-model="loginForm.password" 
                        type="password" 
                        placeholder="请输入密码" 
                        :left-icon="require('../assets/login/pass.png')" 
                        :border="false"
                        />
                        <div class="check_wrap">
                            <van-checkbox v-model="loginForm.remember">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? require('../assets/login/checkon.png') : require('../assets/login/check.png')" />记住密码
                                </template>
                            </van-checkbox>
                            <router-link to="modifypassword">修改密码</router-link>
                        </div>
                        <van-button type="primary"
                        color="linear-gradient(180deg, #4482FF 0%, #226AFF 100%)"
                         @click="sbmit()">登录</van-button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	import wx from 'weixin-js-sdk';
    const Base64 = require('js-base64').Base64
	import {Image,popup,field,Imag,button,CountDown,Toast,Checkbox,icon} from "vant";
	import Qs from 'qs';
	export default {
		components: {
			[popup.name]: popup,
			[field.name]: field,
			[Image.name]:Image,
			[button.name]:button,
			[CountDown.name]:CountDown,
			[Toast.name]:Toast,
            [Checkbox.name]:Checkbox,
            [icon.name]:icon
		},
	  data() {
			return {
                loginForm:{
                    account:'',
                    password:'',
                    remember:false
                }
			}
		},
		
		created(){
            let account = this.getCookie("account")
            let password = Base64.decode(this.getCookie("password"))
            // 如果存在赋值给表单，并且将记住密码勾选
            if(account){
                this.loginForm.account = account
                this.loginForm.password = password
                this.loginForm.remember = true
            }
		},
		methods: {
			sbmit(){
				if(this.loginForm.account===''){
                    this.$message({
                          message: '账号不能为空',
                          type: 'warning'
                    });
					// Toast('');
					return false;
				}
				if(this.loginForm.password===''){
                    this.$message({
                          message: '密码不能为空',
                          type: 'warning'
                    });
					return false;
				}
				this.axios.post(this.ajaxUrl("wuliu","d=wxapi&c=mp_auth&m=login"), Qs.stringify({
					"mobile":this.loginForm.account,
                    "password":this.loginForm.password,
				})).then((res) => {
					if (res.data.success) {
						let list=res.data.data;
                        this.setUserInfo();
                        localStorage.setItem('token',res.data.data.tokencode)
                        localStorage.setItem('session',res.data.session_id)
                        this.$router.push('homeIndex')
					}else{
                        this.$message({
                              message: res.data.message,
                              type: 'warning'
                        });
					}
				})
			},
            // 储存表单信息
            setUserInfo () {
                // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
                // 如果没有勾选，储存的信息为空
                if(this.loginForm.remember){
                    this.$cookie.set("account",this.loginForm.account)
                    // base64加密密码
                    let passWord = Base64.encode(this.loginForm.password)
                    this.$cookie.set("password",passWord)    
                }else{
                    this.$cookie.set("account","")
                    this.$cookie.set("password","") 
                } 
                
            },
            getCookie (key) {
                if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(key + '=')
                if (start !== -1) {
                    start = start + key.length + 1
                    var end = document.cookie.indexOf(';', start)
                    if (end === -1) end = document.cookie.length
                    return unescape(document.cookie.substring(start, end))
                }
                }
                return ''
            },
		},
        watch: {
        }
	}
</script>
<style scoped lang="less">
@import '../style/css/variable.less';

        .login{
            height: 100%;
            overflow: hidden;
            position:fixed;
            top:0;
            left:0;
            width: 100%;
            background: url('../assets/login/bg.png') no-repeat center;
            .flex-center();
            flex-flow: column;
            ::v-deep{
                .login_1{
                    .flex-center();
                    width:100%;
                    .login_1_1{
                        width:24.3%;
                        margin-right: 280px;
                    }
                    .login_1_2{
                        position: relative;
                        width: 32.3%;
                        display: flex;
                        .flex-center();
                        flex-flow: column;
                        padding: 30px;
                        box-sizing: border-box;
                        .login_wrap{
                            width:100%;
                            height: 100%;
                            background: #070C43;
                            position: relative;
                            &::after{position: absolute;left:-30px;bottom:-30px;background: url('../assets/login/4.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                            &::before{position: absolute;right:-30px;bottom:-30px;background: url('../assets/login/3.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                        }
                        .login_title{
                            font-size: 30px;color: @white;padding:50px 0 40px 0;text-align: center;
                        }
                        .login_body{
                            padding: 0 40px;
                            .van-field{
                                height: 60px;background: #02004C;border: 1px solid #86A9D6;
                                .van-field__left-icon{
                                    .flex-center();
                                    margin-right: 20px;
                                    .van-icon{
                                        .flex-center();
                                    }
                                }
                                input{
                                    color: @white;
                                    background: transparent;
                                    &.van-field__control::placeholder{
                                        color: @white;
                                    }
                                }
                                &:first-child{
                                    margin-bottom: 30px;
                                }
                            }
                            .check_wrap{
                                // justify-content: ;
                                margin:20px 0 40px 0;.flex-between();
                                
                                .van-checkbox__icon{.flex-start();
                                    color: #86A9D6;font-size: 14px; line-height: 20px;height: 20px;
                                    img{width: 20px;display: block;
                                        margin-right: 10px;
                                    }
                                }
                                a{
                                  color: #86A9D6;font-size: 14px;  
                                }
                            }
                            .van-cell{
                                line-height: 40px;
                            }
                        }
                        &::after{position: absolute;left:0;top:0;background: url('../assets/login/1.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                        &::before{position: absolute;right:0;top:0;background: url('../assets/login/2.png') no-repeat center;background-size: 58px 58px;content: '';width: 58px;height: 58px;}
                    }
                }
                .van-button{
                    width: 100%;
                	height:60px;
                	line-height: 60px;
                	font-size:20px;
                    margin:0 0 56px 0;
                }
                // .van-checkbox{
                //     margin-right: 0.1rem;
                //     .van-checkbox__icon{
                //         .flex-start();
                //         .van-icon{
                //             width: 0.3rem;
                //             height: 0.3rem;
                //             line-height: 0.3rem;
                //             font-size: 0.3rem;
                //             border: 0.02rem solid #c8c9cc;
                //             &.van-icon-success::before{
                //                 width: 0.3rem;
                //                 height: 0.3rem;
                //                 font-size: 0.3rem;
                //                 line-height: 0.3rem;
                //                 margin:0;
                //             }
                //             &.van-icon-success{
                //                 border: 0.02rem solid @main;
                //             }
                //         }
                //     }
                    
                // }
            }
        }
    
    
</style>